export const broadcast = new EventTarget();

export const broadcastChannels = {
  SecondScreenChange: 0,

  PopupWrapperClick: 1,

  SocketStateChange: 2,

  OpenPopup: 3,

  PrintTicket: 4,

  TitoOperationResult: 5,
  EarlyCashoutResult: 6,

  GetFinancialData: 7,
  GetLastBills: 8,

  ReceivePlayerInfo: 9,
  ReceiveDepositTickets: 10,
  ReceiveCollectedAmount: 11,
  ReceiveIsWithdrawalPinValid: 12,
  ReceiveWithdrawalRequests: 13,
  ReceiveIsWithdrawalState: 14,
  ReceiveWithdrawalTickets: 15,
  ReceivePlayerMaxDepositAmount: 16,
  OneTimeTicketsPrintSuccess: 17,
  ReceiveStackerBalance: 18,
  RecieveTimestampToken: 19,
  ReceiveBetPaymentInfos: 20,

  NetworkTimeChange: 21,
  GetCnpCheckResult: 22,

  ReceiveCashoutSuccess: 23,
  ReceiveCashoutFinished: 24,

  ReceiveDepositToClientAccountSuccess: 25,
  ReceiveDepositToClientAccountFinished: 26,

  BMSContentsReceived: 27,
};
